import React, { useState } from 'react';
import './Instructions.css';

const Instructions = () => {
  // Use emoji images with png extension
  const step1Img = "/images/emoji5.png";
  const step2Img = "/images/emoji6.png";
  const step3Img = "/images/emoji7.png";
  
  // State to track copy feedback
  const [copySuccess, setCopySuccess] = useState(false);
  
  // The prompt text to be copied
  const promptText = `Turn the person in the photo into a 3D emoji-style character. Keep their exact pose, accessories (like phone, jewelry, glasses, etc.), hairstyle, and facial expression. Transform their skin into a smooth yellow emoji-like texture, with simplified, cute, rounded features that match modern emoji aesthetics — but keep their eyes natural and realistic, closely matching the original photo's shape, size, and expression. Stylize the clothing to be clean and minimal, inspired by what they're wearing in the original image. Background should be soft-colored or plain to keep focus on the emoji character. The final result should feel like a playful 3D clay-like emoji version of the original person, but with regular human eyes to keep it expressive and grounded.`;
  
  // Function to copy prompt to clipboard
  const copyPromptToClipboard = () => {
    navigator.clipboard.writeText(promptText).then(() => {
      setCopySuccess(true);
      // Reset the success message after 3 seconds
      setTimeout(() => {
        setCopySuccess(false);
      }, 3000);
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  };

  return (
    <div className="instructions-page">
      <div className="container">
        <h1 className="section-title">How to Mojifi any picture using ChatGPT</h1>
        
        <div className="steps-container">
          <div className="step-card">
            <div className="step-number">1</div>
            <img src={step1Img} alt="Step 1" className="step-image" />
            <h3 className="step-title">Step 1:</h3>
            <p className="step-description">
              Find image of your liking, then open chat gpt prompt.
            </p>
          </div>
          
          <div className="step-card">
            <div className="step-number">2</div>
            <img src={step2Img} alt="Step 2" className="step-image" />
            <h3 className="step-title">Step 2:</h3>
            <p className="step-description">
              <strong>Attach an image and use the prompt below. Replace "person" with whatever suits your image (animal, character etc)</strong>
            </p>
            <div className="prompt-box">
              {promptText}
            </div>
            <div className="copy-prompt-container">
              <button 
                className="copy-prompt-btn" 
                onClick={copyPromptToClipboard}
              >
                {copySuccess ? 'Copied!' : 'Copy Prompt to Clipboard'}
              </button>
            </div>
          </div>
          
          <div className="step-card">
            <div className="step-number">3</div>
            <img src={step3Img} alt="Step 3" className="step-image" />
            <h3 className="step-title">Step 3:</h3>
            <p className="step-description">
              Post in the X community!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Instructions; 